import { Injectable } from '@angular/core';
import * as forge from 'node-forge';
@Injectable({
  providedIn: 'root'
})
export class Utf8EncodingService {

  constructor() { }

  encodeToUtf8(input: string) {
    const utf8 = forge.util.encodeUtf8(input);      // string of bytes
    return forge.util.encode64(utf8);
  }

  decodeFromUtf8(encoded: string) {
    if (!encoded) return null;
    const utf8Out = forge.util.decode64(encoded);
    const jsonStr = forge.util.decodeUtf8(utf8Out);
    return JSON.parse(jsonStr);
  }
}
